import React from 'react'
import ReactDOM from 'react-dom'

import 'assets/fonts/NeueMachina-Ultrabold.otf'
import 'assets/fonts/index.scss'
import 'index.scss'
import './i18n'
import App from 'App'
import * as serviceWorker from 'serviceWorker'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-175158294-1', {
  gaOptions: {
    siteSpeedSampleRate: 100,
  },
})

ReactDOM.render(<App />, document.getElementById('root'))

serviceWorker.unregister()
